/**
 * Cupón "Hot Sale" invisible — el descuento que el catálogo de planes aplica solo,
 * sin que el usuario cargue ningún código. Ver ADR-2026-07-30-copy-catalogo-segun-contexto-abrio.
 *
 * Vive acá porque ahora el catálogo se abre desde más de un lugar
 * (`/subscription` y el sheet de "sin créditos"), y con la consulta duplicada en
 * cada uno el mismo usuario podía ver **dos precios distintos** para el mismo plan
 * según por dónde entró. El id de la fila es fijo: es un cupón puntual, no una
 * búsqueda por estado.
 *
 * Es `es_invisible`: no se muestra como código aplicado, solo baja el precio. El
 * branding de la promo (banner, fuegos) está aparte, detrás de una flag en
 * `Paywall`.
 */
import { supabase } from './supabase';

/** Fila del cupón invisible en `cupones`. */
const HOT_SALE_COUPON_ID = '9e0abd0d-5e0a-4f84-8036-b425f7176207';

export interface AppliedCoupon {
  id: string;
  codigo: string;
  multiplicador: number;
  es_invisible?: boolean;
}

/**
 * Devuelve el cupón si está vigente (activo, sin vencer y sin agotar sus usos), o
 * `null`. **Falla cerrado**: cualquier error devuelve `null`, o sea precio de
 * lista — nunca un descuento que el backend no vaya a respetar.
 */
export async function fetchHotSaleCoupon(): Promise<AppliedCoupon | null> {
  try {
    const { data, error } = await supabase
      .from('cupones')
      .select(
        'id, codigo, multiplicador, activo, usos_maximos, usos_actuales, fecha_expiracion, es_invisible',
      )
      .eq('id', HOT_SALE_COUPON_ID)
      .single();
    if (error || !data || !data.activo) return null;
    const expired =
      data.fecha_expiracion && new Date(data.fecha_expiracion) < new Date();
    const maxedOut =
      data.usos_maximos !== null && data.usos_actuales >= data.usos_maximos;
    if (expired || maxedOut) return null;
    return {
      id: data.id,
      codigo: data.codigo,
      multiplicador: data.multiplicador,
      es_invisible: true,
    };
  } catch {
    return null;
  }
}

export default fetchHotSaleCoupon;
